import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {DonneesUtilisationFlags} from '../parametre-donnees.types';
import {ParametreDonneesStateService} from '../parametre-donnees-state.service';

@Component({
  selector: 'app-parametre-donnees-utilisation-tab',
  templateUrl: './parametre-donnees-utilisation-tab.component.html',
  styleUrls: ['./parametre-donnees-utilisation-tab.component.scss']
})
export class ParametreDonneesUtilisationTabComponent implements OnChanges {
  @Input() moduleKey = 'produits';

  u!: DonneesUtilisationFlags;

  constructor(
    private readonly state: ParametreDonneesStateService,
    private readonly toastr: ToastrService
  ) {}

  ngOnChanges(ch: SimpleChanges): void {
    if (ch['moduleKey']) {
      this.u = this.state.getUtilisationModule(this.moduleKey);
    }
  }

  save(): void {
    this.state.saveModuleUsageApi(this.moduleKey, { ...this.u }).subscribe({
      next: () => this.toastr.success('Utilisation du module enregistrée.', 'Succès'),
      error: () => {}
    });
  }
}
